import React from 'react';

// --- HERBRUIKBARE UI COMPONENTEN (Gekopieerd uit candidate frontend voor consistentie) ---

export const Card = ({ children, className = "", ...props }) => (
  <div className={`bg-white rounded-xl shadow-sm border border-gray-200 p-6 ${className}`} {...props}>
    {children}
  </div>
);

export const Label = ({ children }) => (
  <label className="block text-sm font-semibold text-gray-700 mb-1">
    {children}
  </label>
);

export const Input = (props) => (
  <input
    {...props}
    className="w-full border border-gray-300 rounded-lg px-3 py-3 min-h-[44px] text-gray-800 focus:outline-none focus:ring-2 focus:ring-brand-green focus:border-transparent transition-all disabled:bg-gray-100"
  />
);

export const TextArea = (props) => (
  <textarea
    {...props}
    className="w-full border border-gray-300 rounded-lg px-3 py-3 text-gray-800 focus:outline-none focus:ring-2 focus:ring-brand-green focus:border-transparent transition-all disabled:bg-gray-100 min-h-[100px] resize-y"
  />
);

export const Button = ({ children, disabled, loading, onClick, variant = "primary" }) => {
  const base = "px-6 py-2.5 rounded-lg font-medium transition-all duration-200 flex items-center justify-center";
  const variants = {
    primary: "bg-brand-green text-white hover:opacity-90 disabled:opacity-50",
    secondary: "bg-gray-100 text-gray-700 hover:bg-gray-200 border border-gray-300",
    outline: "border-2 border-gray-200 text-gray-600 hover:border-gray-300 hover:bg-gray-50",
    danger: "bg-red-600 text-white hover:bg-red-700 disabled:bg-red-300"
  };
  
  const isDisabled = disabled || loading;
  
  return (
    <button
      className={`${base} ${variants[variant]} ${isDisabled ? "cursor-not-allowed opacity-70" : "cursor-pointer"}`}
      onClick={onClick}
      disabled={isDisabled}
    >
      {loading ? (
        <>
          <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-current" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
          Verzenden...
        </>
      ) : children}
    </button>
  );
};

